export default __webpack_public_path__ + "static/media/16.99d725c7.jpg";